/**
 * Event Bus Constants
 * Centralized definition of all event names used throughout the application
 */

export default {
  // Real-time notifications events
  realtimeNotifications: {
    // MQTT message received for a specific gallery
    mqtt_message_received: 'realtime_notifications.mqtt_message_received',
    
    // Notification timeout expired and ready to show
    notification_ready: 'realtime_notifications.notification_ready',
    
    // User clicked reload on notification popup
    reload_requested: 'realtime_notifications.reload_requested',
    
    // User closed notification popup
    popup_closed: 'realtime_notifications.popup_closed',
    
    // Request to show popup with specific data
    show_popup: 'realtime_notifications.show_popup'
  },

  // Gallery tree events
  galleryTree: {
    // Gallery data refreshed
    gallery_refreshed: 'gallery_tree.gallery_refreshed',
    
    // Media data updated
    media_updated: 'gallery_tree.media_updated'
  },

  // General app events
  app: {
    // Page reload requested
    page_reload: 'app.page_reload'
  }
}